import { render, staticRenderFns } from "./BatchExpress.vue?vue&type=template&id=2362e6ca&scoped=true"
import script from "./BatchExpress.vue?vue&type=script&lang=js"
export * from "./BatchExpress.vue?vue&type=script&lang=js"
import style0 from "./BatchExpress.vue?vue&type=style&index=0&id=2362e6ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2362e6ca",
  null
  
)

export default component.exports